jQuery(document).ready(function(){
      // Get Vimeo iFrame
      var mediaVideo = jQuery("#intro-video").get(0);
      
      jQuery('#phase-lightbox-close').click(function() {
         mediaVideo.pause();
      });

    jQuery('#play-video, .play-video-img').click(function() {
         setTimeout(function() {
            mediaVideo.play();
         }, 400);

         jQuery('#phase-lightbox').fadeIn('slow');
         jQuery('body').css('overflow', 'hidden');
    });
    jQuery('#phase-lightbox-close').click(function() {
        mediaVideo.pause();
        jQuery('body').css('overflow', 'unset');
        jQuery('#phase-lightbox').fadeOut('slow');
   });
});